"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(text, vol) {
    window.speechSynthesis.resume();
    if (typeof SpeechSynthesisUtterance !== 'undefined' ||
        typeof window.speechSynthesis !== 'undefined') {
        window.speechSynthesis.getVoices();
        window.speechSynthesis.cancel(); // 현재 읽고있다면 초기화
        let speechMsg = new SpeechSynthesisUtterance();
        speechMsg.rate = 0.9; // 속도: 0.1 ~ 10
        speechMsg.pitch = 1; // 음높이: 0 ~ 2
        speechMsg.lang = 'ko-KR';
        speechMsg.text = text;
        speechMsg.volume = vol;
        // SpeechSynthesisUtterance에 저장된 내용을 바탕으로 음성합성 실행
        window.speechSynthesis.speak(speechMsg);
    }
}
exports.default = default_1;
